export class DailylookDetail {
  constructor(acc, average_score, bottom, bottom_color,
    created_at,equipments,hat_color,id,image,
    introduction,is_liked,is_marketing,
    more_images,origin_device_width,outer,
    outerwear_color,shoes,shoes_color,top,top_color,user,) {

    this.acc = acc
    this.average_score = average_score
    this.bottom = bottom
    this.bottom_color = bottom_color
    this.created_at = created_at
    this.equipments = equipments
    this.hat_color = hat_color
    this.id = id
    this.image = image
    this.introduction = introduction
    this.is_liked = is_liked
    this.is_marketing = is_marketing
    this.more_images = more_images
    this.origin_device_width = origin_device_width
    this.outer = outer
    this.outerwear_color = outerwear_color

    this.shoes = shoes
    this.shoes_color = shoes_color
    this.top = top
    this.top_color = top_color
    this.user = user


  }

}